<template>
	<div class="jumbotron jumbotron-fluid">
		<div class="container">
			<h2 class="display-4">Kézako ?</h2>
			<div class="lead">
				<p>Idée de dessin est partie de l'idée de m'aider à trouver des idées à dessiner pour mes créatures. Je n'ai pas trouvé de générateurs de merge sur le web . J'ai donc décidé de le coder moi-même :) Et comme sur notre belle planète nous avons de merveilleux et mystérieux animaux, quoi de plus sympa de s'en servir comme base !</p>
                <h3>Comment ca marche ?</h3>
                <p> Cliquez sur le bouton <strong>Abracadabra</strong> et 2 noms d'animaux apparaient. Vous devez dessiner en mergeant ces 2 animaux et créer votre créature ! Cliquez sur le nom pour voir l'animal.</p>
				<p class="warning">IMPORTANT : L'utilisation d'images sans en avoir les droits est interdites par la loi. Merci de prendre connaissance de la licence des images que vous utilisez avant de l'exploiter. Je ne pourrais pas être tenu pour responsable en cas non de respect. Soyez sympa, faites attention au Copyright ;)</p>
				<span>Amusez-vous bien !!</span>
				<br />Stéphane
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Jubotron"
};
</script>


